import {State as QuoteState} from 'ducks/Quoting/actions';
import {getBaseAddress} from 'features/Quoting/hooks/queries';
import {SESSION_STORAGE_NAMESPACE_QUOTING} from 'types/SessionNamespace';

export const getQuotingStorage = () => {
  try {
    const amicaWebStorage = sessionStorage.getItem(SESSION_STORAGE_NAMESPACE_QUOTING);
    const parsedAmicaWebStorage = amicaWebStorage ? JSON.parse(amicaWebStorage) : undefined;
    const quoting = parsedAmicaWebStorage?.quoting as QuoteState | undefined;
    const quoteAddress = getBaseAddress();
    return {
      state: quoteAddress?.state,
      workOrders: quoting?.workOrders
    };
  } catch (e) {
    return undefined;
  }
};
